/**
 * Component Registry for Wade Crossing Apartment Homes
 * 
 * Inherits from @vibesites-price-brothers/theme-rise and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-price-brothers/theme-rise/registry';
import { Header } from './components/Header';
import AmenitiesList from './components/AmenitiesList';
import SisterProperties from './components/SisterProperties';
import TabbedCallouts from './components/TabbedCallouts';
import Footer from './components/Footer';
import HeroSolidBG from './components/HeroSolidBG';
import PropertyOverview from './components/PropertyOverview';
import FloorplansList from './components/FloorplansList';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  Header,
  HeroSolidBG,
  AmenitiesList,
  SisterProperties,
  TabbedCallouts,
  Footer,
  PropertyOverview,
  FloorplansList,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
